import { App } from 'desktop/containers';
import Home from './../desktop/containers/Home/Loadable';
import RedisMapping from '../RedisMappingLoadable';
import Catalog from 'Catalog/Catalog';
import CompareLooks from './../desktop/containers/CompareLooks/Loadable';
import Checkout from '../desktop/components/Checkout/Loadable';
import Success from './../desktop/containers/Success/Loadable';
import Summary from './../desktop/containers/Summary/Loadable';
import RetryPayment from '../desktop/containers/RetryPayment/Loadable';
import MyAccount from './../desktop/containers/MyAccount/Loadable';
import Reviews from './../CommonComponents/ReviewsLoadable';
import InstaGallery from './../desktop/components/YotpoWidgets/InstaGalleryLoadable';
// import OrderStatus from './../desktop/containers/OrderStatus/OrderStatus';
import ResetPassword from './../desktop/containers/ResetPassword/Loadable';
import ForgotPassword from './../desktop/containers/ForgotPassword/Loadable';
import EditPowerContainer from '../desktop/containers/EditPower/EditPowerContainer';
import LensPackageUpgrade from '../desktop/components/LensPackageUpgrade/LensPackageUpgrade';
// import HTO from './../desktop/containers/HTO/HTO';
import HTO from '../CommonComponents/HTO/layouts/HTO/Loadable';

// import HTOLoadable from '../desktop/containers/HTO/HTOLoadable';
// import Category from 'desktop/containers/Category/Loadable';
import PreSales from '../desktop/components/Checkout/PreSales/PreSales';
import FrameSize from '../CommonComponents/FrameSize/Loadable';
import RefundExchangeFallback from '../desktop/containers/RefundExchange/RefundExchangeFallback';
import QRCodePayment from '../desktop/containers/QRPayment/Loadable';
import ChatBot from '../CommonComponents/ChatBot/Loadable';
import SalesRedirect from '../CommonComponents/SalesRedirect';
import HTORedirect from '../CommonComponents/HTORedirect/HTORedirect';
import JusPayment from '../CommonComponents/JusPayment/JusPayment';
import ConfirmJusPayment from '../CommonComponents/JusPayment/ConfirmJusPayment';
import LeadGen from '../CommonComponents/LeadGen/LeadGen';
// setTimeout(() => {
//   Checkout.preload();
//   Success.preload();
//   Summary.preload();
//   HTOLoadable.preload();
// }, 8000);

const routes = [
  {
    component: App,
    routes: [
      { path: '/(HTO|hto)', component: HTO },
      { path: '/(/*)?', exact: true, component: Home },
      { path: '/promo/:pagename(/*)?', component: Home },
      {
        path: '/(eyeglasses.html|sunglasses.html|premium-eyeglasses|premium-sunglasses)(/*)?',
        exact: true,
        component: Home,
      },
      { path: '/catalog/:id(/*)?', component: Catalog },
      { path: '/category/:id(/*)?', component: Catalog },
      { path: '/catalog/category/view/:id?/:id?/:page?/:page?(/*)?', component: Catalog },
      { path: '/product/:id(/*)?', component: Catalog },
      { path: '/customer-feedback', component: Catalog },
      { path: '/catalog/product/view/:id?/:id?/:page?/:page?/:page?(/*)?', component: Catalog },
      { path: '/compare-looks(/*)?', component: CompareLooks },
      { path: '/(frame-size|frame_size)', component: FrameSize },
      { path: '/customer/account/resetpassword', exact: true, component: ResetPassword },
      { path: '/customer/account/forgotpassword', exact: true, component: ForgotPassword },
      { path: '/customer/*', component: MyAccount },
      { path: '/checkout/onepage/presaleslogin', component: PreSales },
      { path: '/checkout/onepage/success/order-summary', component: Summary },
      { path: '/checkout/onepage/success', component: Success },
      { path: '/checkout/onepage/uploadprescsms', component: Success }, // checkout/((onepage/)uploadprescsms)(?:id)(onepage/success(/))
      { path: '/checkout/onepage/retrypayment', component: RetryPayment },
      { path: '/(checkout/onepage|checkout/onepage/presales)', component: Checkout },
      { path: '/reviews', component: Reviews },
      { path: '/shop-instagram', component: InstaGallery },
      { path: '/editpower/options/view', component: EditPowerContainer },
      {
        path: '/sales/order/(history/order-detail|return-details|return/products)/:id',
        component: RefundExchangeFallback,
      }, // fallback support for return exchange sms/email links
      { path: '/sales/order(/*)?', component: SalesRedirect }, // fallback support for mobile sales url
      { path: '/checkout/payment/qr/:id', component: QRCodePayment },
      { path: '/checkout/payment/collect/:id', component: JusPayment },
      { path: '/checkout/payment/confirm', component: ConfirmJusPayment },
      { path: '/support', component: ChatBot },
      { path: '/home-try-on-program-*', component: HTORedirect },
      { path: '/lead-gen/user-detail', exact: true, component: LeadGen },
      { path: '/lens-package-upgrade/:orderId/:itemId', component: LensPackageUpgrade },
      { path: '/lens-package-upgrade/:orderId', component: LensPackageUpgrade },
      { component: RedisMapping },
    ],
  },
];
export { routes };
